import {register} from '../locale';

register('zh-CN', {
  'Action.countDown': '请等待 ${timeLeft} 秒',
  'Alert.info': '系统消息',
  'asc': '正序',
  'cancel': '取消',
  'Card.dragTip': '请拖动顶部的按钮进行排序',
  'Card.toggleDrag': '对卡片进行排序操作',
  'City.street': '请输入街道信息',
  'clear': '清空',
  'ColorPicker.placeholder': '请选择颜色',
  'Combo.add': '新增',
  'Combo.dragDropSort': '拖拽排序',
  'Combo.invalidData': '数据非法，或者数据已失效，请移除',
  'Combo.maxLength': '组合表单超出{{maxLength}}个，请删除',
  'Combo.minLength': '组合表单数量不足{{minLength}}个，请添加更多',
  'Combo.type': '类型',
  'confirm': '确认',
  'Copyable.tip': '点击复制',
  'CRUD.exportCSV': '导出 CSV',
  'CRUD.exportExcel': '导出 Excel',
  'CRUD.fetchFailed': '获取失败',
  'CRUD.filter': '筛选',
  'CRUD.selected': '已选条目：',
  'CRUD.invalidArray': 'data.items 必须是数组',
  'CRUD.invalidData': '返回数据格式不正确，data 没有数据',
  'CRUD.loadMore': '加载更多',
  'CRUD.perPage': '每页显示',
  'CRUD.stat': '{{page}}/{{lastPage}} 总共：{{total}} 项',
  'CRUD.paginationGoText': '前往',
  'CRUD.paginationPageText': '页',
  'PaginationWrapper.placeholder': '请配置内容',
  'Date.daysago': '{{days}}天前',
  'Date.dayslater': '{{days}}天后',
  'Date.endOfMonth': '本月最后一天',
  'Date.endOfWeek': '周日',
  'Date.endOfLastMonth': '上月最后一天',
  'Date.hoursago': '{{hours}}小时前',
  'Date.hourslater': '{{hours}}小时后',
  'Date.invalid': '日期无效',
  'Date.monday': '本周一',
  'Date.monthsago': '{{months}}月前',
  'Date.monthslater': '{{months}}月后',
  'Date.now': '现在',
  'Date.placeholder': '请选择日期',
  'Date.quartersago': '{{quarters}}季度前',
  'Date.quarterslater': '{{quarters}}季度后',
  'Date.startOfLastMonth': '上个月第一天',
  'Date.startOfLastQuarter': '上个季度第一天',
  'Date.startOfMonth': '本月第一天',
  'Date.startOfQuarter': '本季度第一天',
  'Date.today': '今天',
  'Date.tomorrow': '明天',
  'Date.weeksago': '{{weeks}}周前',
  'Date.weekslater': '{{weeks}}周后',
  'Date.yesterday': '昨天',
  'dateformat.year': 'YYYY年',
  'DateRange.1daysago': '最近1天',
  'DateRange.7daysago': '最近7天',
  'DateRange.30daysago': '最近30天',
  'DateRange.90daysago': '最近90天',
  'DateRange.lastWeek': '上周',
  'DateRange.lastMonth': '上个月',
  'DateRange.lastQuarter': '上个季度',
  'DateRange.placeholder': '请选择日期范围',
  'DateRange.thisWeek': '这个周',
  'DateRange.thisMonth': '这个月',
  'DateRange.thisQuarter': '这个季度',
  'DateRange.valueConcat': ' 至 ',
  'DateTime.placeholder': '请选择日期以及时间',
  'MonthRange.placeholder': '请选择月份范围',
  'delete': '删除',
  'deleteConfirm': '确认要删除？',
  'deleteFailed': '删除失败',
  'desc': '降序',
  'Dialog.close': '关闭',
  'fetchFailed': '初始化失败',
  'File.continueAdd': '继续添加',
  'File.dragDrop': '将文件拖拽到此处',
  'File.errorRetry': '文件上传失败请重试',
  'File.failed': '失败文件',
  'File.invalidType': '{{files}} 不符合类型的 {{accept}} 的设定，请仔细检查',
  'File.maxSize': '{{filename}} 大小为 {{actualSize}} 超出了最大为 {{maxSize}} （字节）的限制',
  'File.pause': '暂停上传',
  'File.repick': '重新选择',
  'File.result': '已成功上传 {{uploaded}} 个文件，{{failed}} 个文件上传失败，',
  'File.retry': '重试上传',
  'File.start': '开始上传',
  'File.upload': '上传文件',
  'File.uploadFailed': '接口返回错误，请仔细检查',
  'File.uploading': '文件上传中',
  'Form.loadOptionsFailed': '加载选项失败，原因：{{reason}}',
  'Form.submit': '提交',
  'Form.title': '表单',
  'Form.unique': '当前值不唯一',
  'Form.validateFailed': '依赖的部分字段没有通过验证',
  'Image.configError': '图片多选配置和裁剪配置只能设置一个',
  'Image.crop': '裁剪图片',
  'Image.dragDrop': '将图片拖拽到此处',
  'Image.height': '高度 {{height}}px',
  'Image.limitRatio': '请上传尺寸比率为 {{ratio}} 的图片',
  'Image.pasteTip': '可以粘贴剪切板中的图片',
  'Image.placeholder': '点击选择图片或拖拽图片到这里',
  'Image.size': '尺寸（{{width}} x {{height}}）',
  'Image.sizeMax': '请上传不要大于{{info}}的图片',
  'Image.sizeMin': '请上传不要小于{{info}}的图片',
  'Image.sizeNotEqual': '请上传{{info}}的图片',
  'Image.width': '宽度 {{width}}px',
  'Image.zoomIn': '查看大图',
  'Image.limitMax': '上传图片大于{{info}},请检查图片尺寸',
  'Image.limitMin': '上传图片小于{{info}},请检查图片尺寸',
  'Log.mustHaveSource': '需要配置 Source',
  'link': '链接',
  'loading': '加载中',
  'LocationPicker.placeholder': '请选择位置',
  'Month.placeholder': '请选择月份',
  'Nav.sourceError': '获取链接错误',
  'networkError': '网络错误，可能是未配置跨域 CORS',
  'noResult': '未找到任何结果',
  'NumberInput.placeholder': '请输入数字',
  'Options.addPlaceholder': '请输入名称',
  'Options.deleteAPI': '必须设置 deleteAPI',
  'Options.editLabel': '编辑{{label}}',
  'Options.label': '选项',
  'placeholder.empty': '<空>',
  'placeholder.enter': '请输入',
  'placeholder.noData': '暂无数据',
  'placeholder.noOption': '暂无选项',
  'placeholder.selectData': '请先选择数据',
  'Quarter.placeholder': '请选择季度',
  'Repeat.pre': '每',
  'reset': '重置',
  'saveFailed': '保存失败',
  'saveSuccess': '保存成功',
  'search': '搜索',
  'searchResult': '搜索结果',
  'Select.checkAll': '全选',
  'Select.clear': '移除',
  'Select.clearAll': '移除所有',
  'Select.createLabel': '新增选项',
  'Select.placeholder': '请选择',
  'Select.searchPromptText': '输入内容进行检索',
  'sort': '排序',
  'SubForm.button': '设置',
  'SubForm.editDetail': '编辑详情',
  'Table.addRow': '新增一行',
  'Table.columnsVisibility': '点击选择显示列',
  'Table.deleteRow': '删除当前行',
  'Table.discard': '放弃',
  'Table.dragTip': '请拖动左边的按钮进行排序',
  'Table.editing': '请先处理表格编辑项',
  'Table.editRow': '编辑当前行',
  'Table.modified': '当前有 {{modified}} 条记录修改但没有提交，你可以：',
  'Table.moved': '当前有 {{moved}} 条记录修改了顺序但没有提交，你可以：',
  'Table.operation': '操作',
  'Table.playload': 'action 上请配置 payload, 否则不清楚要删除哪个',
  'Table.startSort': '点击开始排序',
  'Table.valueField': '请配置 valueField',
  'Tag.placeholder': '暂无标签',
  'Tag.tip': '最近使用的标签',
  'Text.add': '新增：{{label}}',
  'Time.placeholder': '请选择时间',
  'Transfer.configError': '配置错误，选项无法与左侧选项对应',
  'Transfer.refreshIcon': '点击刷新重新加载',
  'Transfer.searchKeyword': '请输入关键字',
  'Transfer.selectd': '当前选择',
  'Transfer.selectFromLeft': '请从左侧选择数据',
  'Tree.addChild': '添加子节点',
  'Tree.addRoot': '添加一级节点',
  'Tree.editNode': '编辑该节点',
  'Tree.removeNode': '移除该节点',
  'Tree.root': '顶级',
  'validate.equals': '输入的数据与 $1 不一致',
  'validate.equalsField': '输入的数据与 $1 值不一致',
  'validate.gt': '请输入大于 $1 的值',
  'validate.isAlpha': '请输入字母',
  'validate.isAlphanumeric': '请输入字母或者数字',
  'validate.isEmail': 'Email 格式不正确',
  'validate.isFloat': '请输入浮点型数值',
  'validate.isId': '请输入合法的身份证号',
  'validate.isInt': '请输入整型数字',
  'validate.isJson': 'JSON 格式不正确',
  'validate.isLength': '请输入长度为 $1 的内容',
  'validate.isNumeric': '请输入数字',
  'validate.isPhoneNumber': '请输入合法的手机号码',
  'validate.isRequired': '这是必填项',
  'validate.isTelNumber': '请输入合法的电话号码',
  'validate.isUrl': 'URL 格式不正确',
  'validate.isUrlPath': '只能输入字母、数字、`-` 和 `_`.',
  'validate.isWords': '请输入单词',
  'validate.isZipcode': '请输入合法的邮编地址',
  'validate.lt': '请输入小于 $1 的值',
  'validate.matchRegexp': '格式不正确, 请输入符合规则为 `${1|raw}` 的内容。',
  'validate.maximum': '当前输入值超出最大值 $1',
  'validate.maxLength': '请控制内容长度, 不要输入 $1 个以上字符',
  'validate.minimum': '当前输入值低于最小值 $1',
  'validate.minLength': '请输入更多的内容，至少输入 $1 个字符。',
  'validate.notEmptyString': '请不要全输入空白字符',
  'validateFailed': '表单验证失败',
  'Wizard.configError': '配置错误',
  'Wizard.finish': '完成',
  'Wizard.next': '下一步',
  'Wizard.prev': '上一步',
  'Wizard.saveAndNext': '保存并下一步',
  'year-to-year': '{{from}} 年 - {{to}} 年',
  'Year.placeholder': '请选择年'
});
